/* eslint-disable no-unused-vars */
// noinspection JSUnusedGlobalSymbols,JSValidateJSDoc

import { register, CloudObject, Tag, Transaction, defineProperty, defineRelation } from 'olympe';

/**
 * @extends {CloudObject}
 */
export default class BCP extends CloudObject {

    /**
     * Creates an instance of BCP.
     *
     * @param {!Transaction} transaction
     * @return {!string} the tag of the created instance
     */
    static create(transaction) {
        return transaction.create(BCP);
    }

    /**
     * @return {string}
     */
    getBusinessPartner() {
        return this.get(BCP.businessPartnerProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeBusinessPartner($) {
        return this.observe($, BCP.businessPartnerProp);
    }

    /**
     * @return {string}
     */
    getProcurementManager() {
        return this.get(BCP.procurementManagerProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeProcurementManager($) {
        return this.observe($, BCP.procurementManagerProp);
    }

    /**
     * @return {string}
     */
    getTechnicalApplicationGroup() {
        return this.get(BCP.technicalApplicationGroupProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeTechnicalApplicationGroup($) {
        return this.observe($, BCP.technicalApplicationGroupProp);
    }

    /**
     * @return {string}
     */
    getQualityAssurance() {
        return this.get(BCP.qualityAssuranceProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeQualityAssurance($) {
        return this.observe($, BCP.qualityAssuranceProp);
    }

    /**
     * @return {string}
     */
    getRemark() {
        return this.get(BCP.remarkProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeRemark($) {
        return this.observe($, BCP.remarkProp);
    }

    /**
     * @return {string}
     */
    getRequestor() {
        return this.get(BCP.requestorProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeRequestor($) {
        return this.observe($, BCP.requestorProp);
    }

    /**
     * @return {string}
     */
    getAlternativeVendorCode() {
        return this.get(BCP.alternativeVendorCodeProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeAlternativeVendorCode($) {
        return this.observe($, BCP.alternativeVendorCodeProp);
    }

    /**
     * @return {Date}
     */
    getRequestDate() {
        return this.get(BCP.requestDateProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeRequestDate($) {
        return this.observe($, BCP.requestDateProp);
    }

    /**
     * @return {string}
     */
    getMaterialId() {
        return this.get(BCP.materialIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMaterialId($) {
        return this.observe($, BCP.materialIdProp);
    }

    /**
     * @return {string}
     */
    getMaterialDescription() {
        return this.get(BCP.materialDescriptionProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMaterialDescription($) {
        return this.observe($, BCP.materialDescriptionProp);
    }

    /**
     * @return {string}
     */
    getPlantId() {
        return this.get(BCP.plantIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observePlantId($) {
        return this.observe($, BCP.plantIdProp);
    }

    /**
     * @return {string}
     */
    getPlantDescription() {
        return this.get(BCP.plantDescriptionProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observePlantDescription($) {
        return this.observe($, BCP.plantDescriptionProp);
    }

    /**
     * @return {string}
     */
    getRejectedNote() {
        return this.get(BCP.rejectedNoteProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeRejectedNote($) {
        return this.observe($, BCP.rejectedNoteProp);
    }

    /**
     * @return {number}
     */
    getStatus() {
        return this.get(BCP.statusProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeStatus($) {
        return this.observe($, BCP.statusProp);
    }

    /**
     * @return {string}
     */
    getBCPStatus() {
        return this.get(BCP.bCPStatusProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeBCPStatus($) {
        return this.observe($, BCP.bCPStatusProp);
    }

    /**
     * @return {string}
     */
    getNotification_stage() {
        return this.get(BCP.notification_stageProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeNotification_stage($) {
        return this.observe($, BCP.notification_stageProp);
    }

    /**
     * @return {string}
     */
    getSpecification() {
        return this.get(BCP.specificationProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeSpecification($) {
        return this.observe($, BCP.specificationProp);
    }

    /**
     * @return {string}
     */
    getQaInFactory() {
        return this.get(BCP.qaInFactoryProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeQaInFactory($) {
        return this.observe($, BCP.qaInFactoryProp);
    }

    /**
     * @return {string}
     */
    getTargetBCP() {
        return this.get(BCP.targetBCPProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeTargetBCP($) {
        return this.observe($, BCP.targetBCPProp);
    }

    /**
     * @return {string}
     */
    getPriority() {
        return this.get(BCP.priorityProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observePriority($) {
        return this.observe($, BCP.priorityProp);
    }

    /**
     * @return {string}
     */
    getCostSavings() {
        return this.get(BCP.costSavingsProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeCostSavings($) {
        return this.observe($, BCP.costSavingsProp);
    }

    /**
     * @return {string}
     */
    getGhgReduction() {
        return this.get(BCP.ghgReductionProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeGhgReduction($) {
        return this.observe($, BCP.ghgReductionProp);
    }

    /**
     * @return {string}
     */
    getMainVendorLinkedAltVendor() {
        return this.get(BCP.mainVendorLinkedAltVendorProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMainVendorLinkedAltVendor($) {
        return this.observe($, BCP.mainVendorLinkedAltVendorProp);
    }

    /**
     * @return {Date}
     */
    getCtagCompletionDueDate() {
        return this.get(BCP.ctagCompletionDueDateProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeCtagCompletionDueDate($) {
        return this.observe($, BCP.ctagCompletionDueDateProp);
    }

    /**
     * @return {Date}
     */
    getQaInFactoryCompletionDueDate() {
        return this.get(BCP.qaInFactoryCompletionDueDateProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeQaInFactoryCompletionDueDate($) {
        return this.observe($, BCP.qaInFactoryCompletionDueDateProp);
    }

    /**
     * @return {number}
     */
    getDocumentFileStatus() {
        return this.get(BCP.documentFileStatusProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeDocumentFileStatus($) {
        return this.observe($, BCP.documentFileStatusProp);
    }

    /**
     * @return {number}
     */
    getVsiStatus() {
        return this.get(BCP.vsiStatusProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeVsiStatus($) {
        return this.observe($, BCP.vsiStatusProp);
    }

    /**
     * @return {number}
     */
    getTrialStatus() {
        return this.get(BCP.trialStatusProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeTrialStatus($) {
        return this.observe($, BCP.trialStatusProp);
    }

    /**
     * @return {number}
     */
    getVamStatus() {
        return this.get(BCP.vamStatusProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeVamStatus($) {
        return this.observe($, BCP.vamStatusProp);
    }

    /**
     * @return {Date}
     */
    getSqaCompletionDueDate() {
        return this.get(BCP.sqaCompletionDueDateProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<Date>}
     */
    observeSqaCompletionDueDate($) {
        return this.observe($, BCP.sqaCompletionDueDateProp);
    }

    /**
     * @return {string}
     */
    getAdminFirstQualityAcceptance() {
        return this.get(BCP.adminFirstQualityAcceptanceProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeAdminFirstQualityAcceptance($) {
        return this.observe($, BCP.adminFirstQualityAcceptanceProp);
    }

    /**
     * @return {string}
     */
    getMainVendorId() {
        return this.get(BCP.mainVendorIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMainVendorId($) {
        return this.observe($, BCP.mainVendorIdProp);
    }

    /**
     * @return {string}
     */
    getMainVendorDescription() {
        return this.get(BCP.mainVendorDescriptionProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMainVendorDescription($) {
        return this.observe($, BCP.mainVendorDescriptionProp);
    }

    /**
     * @return {string}
     */
    getCurrentVendorSiteId() {
        return this.get(BCP.currentVendorSiteIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeCurrentVendorSiteId($) {
        return this.observe($, BCP.currentVendorSiteIdProp);
    }

    /**
     * @return {string}
     */
    getCurrentVendorSiteDescription() {
        return this.get(BCP.currentVendorSiteDescriptionProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeCurrentVendorSiteDescription($) {
        return this.observe($, BCP.currentVendorSiteDescriptionProp);
    }

    /**
     * @return {number}
     */
    getInputSavingEstimates() {
        return this.get(BCP.inputSavingEstimatesProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<number>}
     */
    observeInputSavingEstimates($) {
        return this.observe($, BCP.inputSavingEstimatesProp);
    }

    /**
     * @return {string}
     */
    getRequestId() {
        return this.get(BCP.requestIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeRequestId($) {
        return this.observe($, BCP.requestIdProp);
    }

    /**
     * @return {string}
     */
    getMaguireEligibility() {
        return this.get(BCP.maguireEligibilityProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeMaguireEligibility($) {
        return this.observe($, BCP.maguireEligibilityProp);
    }

    /**
     * @return {string}
     */
    getOscarId() {
        return this.get(BCP.oscarIdProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeOscarId($) {
        return this.observe($, BCP.oscarIdProp);
    }

    /**
     * @return {string}
     */
    getProcurementSpecialist() {
        return this.get(BCP.procurementSpecialistProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeProcurementSpecialist($) {
        return this.observe($, BCP.procurementSpecialistProp);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setBusinessPartner(transaction, instance, value) {
        transaction.update(instance, BCP.businessPartnerProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setProcurementManager(transaction, instance, value) {
        transaction.update(instance, BCP.procurementManagerProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setTechnicalApplicationGroup(transaction, instance, value) {
        transaction.update(instance, BCP.technicalApplicationGroupProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setQualityAssurance(transaction, instance, value) {
        transaction.update(instance, BCP.qualityAssuranceProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setRemark(transaction, instance, value) {
        transaction.update(instance, BCP.remarkProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setRequestor(transaction, instance, value) {
        transaction.update(instance, BCP.requestorProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setAlternativeVendorCode(transaction, instance, value) {
        transaction.update(instance, BCP.alternativeVendorCodeProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setRequestDate(transaction, instance, value) {
        transaction.update(instance, BCP.requestDateProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMaterialId(transaction, instance, value) {
        transaction.update(instance, BCP.materialIdProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMaterialDescription(transaction, instance, value) {
        transaction.update(instance, BCP.materialDescriptionProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setPlantId(transaction, instance, value) {
        transaction.update(instance, BCP.plantIdProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setPlantDescription(transaction, instance, value) {
        transaction.update(instance, BCP.plantDescriptionProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setRejectedNote(transaction, instance, value) {
        transaction.update(instance, BCP.rejectedNoteProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setStatus(transaction, instance, value) {
        transaction.update(instance, BCP.statusProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setBCPStatus(transaction, instance, value) {
        transaction.update(instance, BCP.bCPStatusProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setNotification_stage(transaction, instance, value) {
        transaction.update(instance, BCP.notification_stageProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setSpecification(transaction, instance, value) {
        transaction.update(instance, BCP.specificationProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setQaInFactory(transaction, instance, value) {
        transaction.update(instance, BCP.qaInFactoryProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setTargetBCP(transaction, instance, value) {
        transaction.update(instance, BCP.targetBCPProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setPriority(transaction, instance, value) {
        transaction.update(instance, BCP.priorityProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setCostSavings(transaction, instance, value) {
        transaction.update(instance, BCP.costSavingsProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setGhgReduction(transaction, instance, value) {
        transaction.update(instance, BCP.ghgReductionProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMainVendorLinkedAltVendor(transaction, instance, value) {
        transaction.update(instance, BCP.mainVendorLinkedAltVendorProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setCtagCompletionDueDate(transaction, instance, value) {
        transaction.update(instance, BCP.ctagCompletionDueDateProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setQaInFactoryCompletionDueDate(transaction, instance, value) {
        transaction.update(instance, BCP.qaInFactoryCompletionDueDateProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setDocumentFileStatus(transaction, instance, value) {
        transaction.update(instance, BCP.documentFileStatusProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setVsiStatus(transaction, instance, value) {
        transaction.update(instance, BCP.vsiStatusProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setTrialStatus(transaction, instance, value) {
        transaction.update(instance, BCP.trialStatusProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setVamStatus(transaction, instance, value) {
        transaction.update(instance, BCP.vamStatusProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {Date} value
     */
    static setSqaCompletionDueDate(transaction, instance, value) {
        transaction.update(instance, BCP.sqaCompletionDueDateProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setAdminFirstQualityAcceptance(transaction, instance, value) {
        transaction.update(instance, BCP.adminFirstQualityAcceptanceProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMainVendorId(transaction, instance, value) {
        transaction.update(instance, BCP.mainVendorIdProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMainVendorDescription(transaction, instance, value) {
        transaction.update(instance, BCP.mainVendorDescriptionProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setCurrentVendorSiteId(transaction, instance, value) {
        transaction.update(instance, BCP.currentVendorSiteIdProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setCurrentVendorSiteDescription(transaction, instance, value) {
        transaction.update(instance, BCP.currentVendorSiteDescriptionProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {number} value
     */
    static setInputSavingEstimates(transaction, instance, value) {
        transaction.update(instance, BCP.inputSavingEstimatesProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setRequestId(transaction, instance, value) {
        transaction.update(instance, BCP.requestIdProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setMaguireEligibility(transaction, instance, value) {
        transaction.update(instance, BCP.maguireEligibilityProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setOscarId(transaction, instance, value) {
        transaction.update(instance, BCP.oscarIdProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setProcurementSpecialist(transaction, instance, value) {
        transaction.update(instance, BCP.procurementSpecialistProp, value);
    }

    /**
    * @param {!Transaction} transaction
    * @param {!Tag} instance
    * @param {string} value
    */
    static setVdetName(transaction, instance, value) {
        transaction.update(instance, BCP.vdetNameProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setVdetAddress(transaction, instance, value) {
        transaction.update(instance, BCP.vdetAddressProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setVdetCity(transaction, instance, value) {
        transaction.update(instance, BCP.vdetCityProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setVdetCountry(transaction, instance, value) {
        transaction.update(instance, BCP.vdetCountryProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setVdetEmail(transaction, instance, value) {
        transaction.update(instance, BCP.vdetEmailProp, value);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setVdetContactNumber(transaction, instance, value) {
        transaction.update(instance, BCP.vdetContactNumberProp, value);
    }

    /**
     * @return {string}
     */
    getSpendCategory1() {
        return this.get(BCP.spendCategory1Prop);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeSpendCategory1($) {
        return this.observe($, BCP.spendCategory1Prop);
    }

    /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
    static setSpendCategory1(transaction, instance, value) {
        transaction.update(instance, BCP.spendCategory1Prop, value);
    }

     /**
     * @param {!Transaction} transaction
     * @param {!Tag} instance
     * @param {string} value
     */
     static setRejectionReasonComment(transaction, instance, value) {
        transaction.update(instance, BCP.rejectionReasonCommentProp, value);
    }

    /**
    * @return {string}
    */
    getVdetName() {
        return this.get(BCP.vdetNameProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeVdetName($) {
        return this.observe($, BCP.vdetNameProp);
    }

    /**
     * @return {string}
     */
    getVdetAddress() {
        return this.get(BCP.vdetAddressProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeVdetAddress($) {
        return this.observe($, BCP.vdetAddressProp);
    }

    /**
     * @return {string}
     */
    getVdetCity() {
        return this.get(BCP.vdetCityProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeVdetCity($) {
        return this.observe($, BCP.vdetCityProp);
    }

    /**
     * @return {string}
     */
    getVdetCountry() {
        return this.get(BCP.vdetCountryProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeVdetCountry($) {
        return this.observe($, BCP.vdetCountryProp);
    }

    /**
     * @return {string}
     */
    getVdetEmail() {
        return this.get(BCP.vdetEmailProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeVdetEmail($) {
        return this.observe($, BCP.vdetEmailProp);
    }

    /**
     * @return {string}
     */
    getVdetContactNumber() {
        return this.get(BCP.vdetContactNumberProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeVdetContactNumber($) {
        return this.observe($, BCP.vdetContactNumberProp);
    }

    /**
    * @return {string}
    */
    getRejectionReasonComment() {
        return this.get(BCP.rejectionReasonCommentProp);
    }

    /**
     * @param {!BrickContext} $
     * @return {!Observable<string>}
     */
    observeRejectionReasonComment($) {
        return this.observe($, BCP.rejectionReasonCommentProp);
    }
}

// Hardcoded tags
register('0187ff8a982169bff01e', BCP);
BCP.businessPartnerProp = defineProperty('0187ff8ad8f37f53a10d');
BCP.procurementManagerProp = defineProperty('0187ff8ae9c57f8bbd1c');
BCP.technicalApplicationGroupProp = defineProperty('0187ff8b41b8770bff3f');
BCP.qualityAssuranceProp = defineProperty('0187ff8b7ff0264d9a34');
BCP.remarkProp = defineProperty('0187ff902589183b7379');
BCP.requestorProp = defineProperty('0187ff9044fcb7bad53e');
BCP.alternativeVendorCodeProp = defineProperty('0187ff946ddf45c5ae79');
BCP.requestDateProp = defineProperty('0187ff9f4c74b8fa2f11');
BCP.materialIdProp = defineProperty('0188041c601f1710d6c5');
BCP.materialDescriptionProp = defineProperty('0188041c6c9f41022a85');
BCP.plantIdProp = defineProperty('0188041c892484107fd0');
BCP.plantDescriptionProp = defineProperty('0188041d0e86870cc66d');
BCP.rejectedNoteProp = defineProperty('018804855bb441515c92');
BCP.statusProp = defineProperty('0188b3df0862133190d9');
BCP.bCPStatusProp = defineProperty('018907314a3dc3ed1d5b');
BCP.notification_stageProp = defineProperty('0189d98174750f5e520e');
BCP.specificationProp = defineProperty('018a8f1888510b038390');
BCP.qaInFactoryProp = defineProperty('0192d2b17a264f0c488b');
BCP.targetBCPProp = defineProperty('0192d2b2e395c58538e5');
BCP.priorityProp = defineProperty('0192d2b3dc812a12acce');
BCP.costSavingsProp = defineProperty('0192d2b41477f1fc6762');
BCP.ghgReductionProp = defineProperty('0192d2b450f6614b646c');
BCP.mainVendorLinkedAltVendorProp = defineProperty('0192d2b485580964c5b9');
BCP.ctagCompletionDueDateProp = defineProperty('0192d2b50b85782bfdda');
BCP.qaInFactoryCompletionDueDateProp = defineProperty('0192d2b5452f8fc6d67b');
BCP.documentFileStatusProp = defineProperty('01930bbc2cd014d4d0eb');
BCP.vsiStatusProp = defineProperty('01930bbd27613612e5e5');
BCP.trialStatusProp = defineProperty('01930bbd5f19b6fba4c5');
BCP.vamStatusProp = defineProperty('01930bc459077fabc3fd');
BCP.sqaCompletionDueDateProp = defineProperty('01931aa44504eb3deea8');
BCP.adminFirstQualityAcceptanceProp = defineProperty('01935a58f052eae6eb49');
BCP.mainVendorIdProp = defineProperty('019362c16bdbacd111e8');
BCP.mainVendorDescriptionProp = defineProperty('019362c199ab47b33499');
BCP.currentVendorSiteIdProp = defineProperty('019362c21e76eb827873');
BCP.currentVendorSiteDescriptionProp = defineProperty('019362c25ec42e33ad0a');
BCP.inputSavingEstimatesProp = defineProperty('0193cf8f5ea107ef3e9c');
BCP.requestIdProp = defineProperty('019504a661dbdefd1bb6');
BCP.maguireEligibilityProp = defineProperty('0196589280c136018f49');
BCP.oscarIdProp = defineProperty('01965892dc59de7d84ae');
BCP.procurementSpecialistProp = defineProperty('019782296eaa342559bd');
BCP.vdetNameProp = defineProperty('0198bc7c174b9bdb2a9f');
BCP.vdetAddressProp = defineProperty('0198bc7c71b2f23032e8');
BCP.vdetCityProp = defineProperty('0198bc7caa98ff86c09f');
BCP.vdetCountryProp = defineProperty('0198bc7ce34180d4d9cc');
BCP.vdetEmailProp = defineProperty('0198bc7d1d06dd91b4b9');
BCP.vdetContactNumberProp = defineProperty('0198bc7da389d59232ae');
BCP.spendCategory1Prop = defineProperty('0199e1df4cfdf06fd389');
BCP.rejectionReasonCommentProp = defineProperty('019aa0c6e48945afb2bd');

